export const MODIFIER_GROUP_TITLE_INPUT_MAX_LENGTH = 100;
export const getModifierGroupsIds = items => {
  const modifierGroupIds = items.flatMap(item => (item.modifierGroups || []).map(modifierGroup => modifierGroup.id)).filter(Boolean);
  const modifierGroupIdsWithoutDuplicates = new Set(modifierGroupIds);
  return [...modifierGroupIdsWithoutDuplicates];
};
export const getItemsPopulatedModifierGroups = (modifierGroups, populatedModifierGroupsMap) => {
  return modifierGroups.map(modifierGroup => {
    const populatedModifierGroup = populatedModifierGroupsMap[modifierGroup.id];
    return populatedModifierGroup;
  }).filter(modifierGroup => modifierGroup !== undefined);
};
export const getDuplicateModifierGroupName = (duplicatedNameCreator, name) => duplicatedNameCreator(name).substring(0, MODIFIER_GROUP_TITLE_INPUT_MAX_LENGTH);
export const getAllItemsModifierGroups = items => {
  return items.reduce((modifierGroupsArr, item) => {
    return [...modifierGroupsArr, ...(item.modifierGroups || [])];
  }, []);
};
//# sourceMappingURL=modifierGroups.js.map